module.exports = __webpack_public_path__ + "static/media/roboto-700italic.da0e7178.woff2";